import * as yup from 'yup';

export const AddPermitsForm = yup.object().shape({
  permitSelections: yup
    .array()
    .of(
      yup.object().shape({
        quantity: yup.number().min(0).required(),
        typeId: yup.string().required(),
        typeOriginalId: yup.string().required(),
      }),
    )
    .required(),
});

export type AddPermitsForm = yup.InferType<typeof AddPermitsForm>;
